import React from "react";
import { useSelector } from "react-redux";
import ModalBase from "./ModalBase";
import { ReactComponent as ErodeMark } from "../../assets/icons/erode-mark-new.svg";

interface WelcomeTourModalProps {
  // Provided by ModalGlobal — carries the tour result back to VerticalNav.
  onClose?: (result?: { modalType: string; startTour: boolean }) => void;
}

// First-run welcome card. "Show me around" kicks off the guided tour; either button
// records that the welcome was seen so it never reappears (handled in VerticalNav).
const WelcomeTourModal: React.FC<WelcomeTourModalProps> = ({ onClose }) => {
  const name = useSelector((state: any) => state.user?.permissionDetails?.name);
  const firstName = name ? String(name).split(" ")[0] : null;

  const close = (startTour: boolean) => onClose?.({ modalType: "welcomeTour", startTour });

  return (
    <ModalBase
      title={firstName ? `Welcome, ${firstName}!` : "Welcome to Erode"}
      icon={<ErodeMark className="w-6 h-6" />}
      size="md"
      onClose={() => close(false)}
      footer={
        <>
          <button type="button" onClick={() => close(false)} className="eai-btn px-4">
            Skip for now
          </button>
          <button type="button" onClick={() => close(true)} className="eai-btn-grn px-4">
            Show me around
          </button>
        </>
      }
    >
      <div className="space-y-4 text-sm leading-relaxed text-gray-600">
        <p>
          Erode turns weather, water, and energy data into operational decisions you can act on this
          week — with the financial impact spelled out.
        </p>
        <div className="rounded-md bg-eai-checklist-lt p-4">
          <p className="font-semibold text-gray-900">Your AI Analyst can:</p>
          <ul className="mt-2 space-y-1.5 list-disc list-inside">
            <li>Surface insights for your assets that are actionable in the next 3–5 days</li>
            <li>Set up assets and pull in the data behind every answer</li>
            <li>Schedule recurring insights and alerts so you never miss a change or action to take</li>
          </ul>
        </div>
        <p>
          Let&apos;s take a quick look around so you know exactly where everything is.
        </p>
      </div>
    </ModalBase>
  );
};

export default WelcomeTourModal;
